// Pausearket: hus-knappen midt i en bane. IGN runde 2: knappen sendte spilleren direkte til titlen,
// og banen så ud til at køre videre bagved. Nu står tiden stille, og Fortsæt er det fremhævede valg.

import { h } from '../dom';
import { ICON } from '../icons';

export interface PauseInfo {
  /** Banens navn, fx "Thor går i land". */
  level: string;
  /** Året i banen, fx "2036". */
  year: string;
}

export interface PauseHandlers {
  resume(): void;
  settings(): void;
  home(): void;
  /** Vis tips-turen igen. */
  tips?: () => void;
  /** Lad AI spille herfra (kun solo). */
  ai?: () => void;
}

export function pauseScreen(v: PauseInfo, handlers: PauseHandlers): HTMLElement {
  return h(
    'div',
    { class: 'card pause', role: 'dialog', 'aria-modal': 'true', 'aria-labelledby': 'pause-title' },
    h('h1', { class: 'title small', id: 'pause-title' }, 'PAUSE'),
    h('p', { class: 'pause-where' }, `${v.level} · ${v.year}`),
    h('p', { class: 'help' }, 'Tiden står stille, og mørkeurene venter. Banen er her, når du kommer tilbage.'),
    h(
      'div',
      { class: 'actions' },
      h('button', { type: 'button', class: 'btn primary', autofocus: true, 'data-act': 'resume', onclick: () => handlers.resume() }, h('span', { html: ICON.play }), 'Fortsæt'),
      handlers.ai ? h('button', { type: 'button', class: 'btn ghost', 'data-act': 'ai', onclick: () => handlers.ai?.() }, h('span', { html: ICON.robot }), 'Lad AI spille') : null,
      handlers.tips ? h('button', { type: 'button', class: 'btn ghost', 'data-act': 'tips', onclick: () => handlers.tips?.() }, 'Vis tips igen') : null,
      h('button', { type: 'button', class: 'btn ghost', 'data-act': 'settings', onclick: () => handlers.settings() }, 'Indstillinger'),
      h('button', { type: 'button', class: 'btn ghost', 'data-act': 'home', onclick: () => handlers.home() }, h('span', { html: ICON.home }), 'Til forsiden'),
    ),
  );
}
